import { useMemo } from 'react';
import sortBy from 'lodash/sortBy';

import {
  SUGGESTED_ANSWER_EXAMPLE,
  SUGGESTED_ANSWER_FIXED,
  SUGGESTED_ANSWER_VARY,
} from 'global/constants';
import { RichtextDisplay } from '../../teaching-notes/teaching-notes-drawer.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import SuggestedAnswerTitle from '../suggested-answer-title';
import { Box } from 'approot/shared/design-system/box/box.style';
import { getRichtextAnswer } from '../../shared/logic/get-richtext-answer';
import { SUGGESTED_ANSWER_BASE_RICHTEXT } from '../suggested-answer.constants';
import {
  getRichtextValue,
  isRichtextValueEmpty,
} from '../../shared/logic/get-richtext-value';
import { ComponentResponse } from '../../component.constants';
import SuggestedAnswerViewBadges from './suggested-answer-view-badges';

type Props = {
  component: ComponentResponse;
  isUnitQuiz: boolean;
};

const SuggestedAnswerTextResponseView = ({ component, isUnitQuiz }: Props) => {
  const { properties, suggestedAnswerProperties, subActivityProperties } =
    component;
  const answerType = suggestedAnswerProperties?.suggestedAnswerType;

  const sortedFields = useMemo(
    () => sortBy(properties.textResponse.fields, 'sort'),
    [properties.textResponse.fields]
  );

  const hasNoRichTextData = useMemo(
    () =>
      answerType !== SUGGESTED_ANSWER_VARY &&
      suggestedAnswerProperties?.suggestedAnswers?.every(suggestedData =>
        isRichtextValueEmpty(getRichtextAnswer(suggestedData))
      ),
    [answerType, suggestedAnswerProperties]
  );

  return hasNoRichTextData && !isUnitQuiz ? null : (
    <Box>
      <SuggestedAnswerTitle
        isSmall
        label={subActivityProperties?.subActivityLabel}
        instructions={subActivityProperties?.instructions}
      />

      <SuggestedAnswerViewBadges
        isExampleAnswer={
          answerType === SUGGESTED_ANSWER_EXAMPLE && !hasNoRichTextData
        }
        isFixedAnswer={
          answerType === SUGGESTED_ANSWER_FIXED && !hasNoRichTextData
        }
        suggestedAnswerScore={suggestedAnswerProperties?.suggestedAnswersScore}
        isUnitQuiz={isUnitQuiz}
      />

      {answerType === SUGGESTED_ANSWER_VARY ? (
        <PStyled>Answers may vary</PStyled>
      ) : (
        sortedFields.map(field => {
          const answer = getRichtextAnswer(
            suggestedAnswerProperties?.suggestedAnswers?.find(
              sa => sa.answerReferences?.id === field.itemId
            )
          );
          return !isRichtextValueEmpty(answer) ? (
            <Box key={field.itemId} $marginBottom={8}>
              <RichtextDisplay
                dangerouslySetInnerHTML={{
                  __html: getRichtextValue(
                    answer,
                    SUGGESTED_ANSWER_BASE_RICHTEXT
                  ),
                }}
              />
            </Box>
          ) : null;
        })
      )}
    </Box>
  );
};

export default SuggestedAnswerTextResponseView;
